// extracted by mini-css-extract-plugin
export default {"overlay":"Wz-z","bodyOpen":"Xz-z","content":"Yz-z","header":"Zz-z","closeNoHeading":"_z-z"};